import * as _ from 'lodash';

/**
 * A helper base class to provide a getId method that can be used to generate a unique id automatically
 */
export class GetId {
  protected getId(id: number | string = _.uniqueId()): string {
    return `${_.lowerFirst(this.constructor.name)}_${id}`;
  }
}
